import { useEffect, useState } from 'react';

const useIsRelif = () => {
  const [isRelif, setIsRelif] = useState(false);
  const [isPlaner, setIsPlaner] = useState(false);

  useEffect(() => {
    const { hostname, port } = window.location;
    setIsRelif(hostname.includes('relif.cl') || port === '3009');
    setIsPlaner(hostname.includes('planer.ai') || port === '3002');
  }, []);

  return { isRelif, isPlaner };
};

export default useIsRelif;
